/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useAuth } from '../../../hooks/useAuth';
import { keys } from '../../api.keys';
import { queryPunterSupportedBets } from './supportedBets';
import { TPunterSupportedBetsResponse } from './supportedBets.types';

type TQueryHook = {
  key?: any[];
  options?: UseQueryOptions<TPunterSupportedBetsResponse>;
};

export const useQuerySupportedBets = ({
  key = [],
  options = {},
}: TQueryHook = {}) => {
  const { isAuthenticated } = useAuth();

  const query = useQuery(
    [keys.supportedBets, !!isAuthenticated, ...key],
    queryPunterSupportedBets,
    {
      staleTime: 60 * 1000, // 1 minute
      enabled: !!isAuthenticated,
      ...(options as any),
    }
  );

  return query;
};
